import React, { Suspense, lazy } from 'react';
/**
 * Admin mascot preview page — lazy-loads the heavy DjayShowcase chunk so
 * it stays out of the main admin bundle until an admin actually opens it.
 *
 * Tracked in MASCOT_DOMAIN_AUDIT_2026 §3.2 (lazy-load open item, addressed ronde 7).
 */
const DjayShowcase = lazy(() => import('../../../mascot/DjayShowcase').then(m => ({
  default: m.DjayShowcase
})));
export function MascotPage() {
  return <Suspense fallback={null} data-id="element-5624">
      <DjayShowcase data-id="element-5625" />
    </Suspense>;
}